import { HIDDEN_COLUMNS } from '../constant/constants';
import { Column } from '../enum/Column';

/**
 * Filters out columns that should not be displayed on the frontend.
 * This utility removes any column names that are listed in the `HIDDEN_COLUMNS` constant.
 *
 * @param columns - An array of column names returned from the backend.
 * @returns A filtered array containing only visible column names.
 */

export function filterVisibleColumns(columns: Column[]): Column[] {
  return columns.filter((col) => !HIDDEN_COLUMNS.includes(col.name));
}
